import {useEffect, useRef, useState} from "react";
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import axios from "../config/axios-chatbot";
import {TOKEN} from "../context/SignInContext";

export const useStompWebsocket = (topic) => {
  const stompClientRef = useRef(null);
  const [updatedValue, setUpdatedValue] = useState(null);
  const [status, setStatus] = useState(null);


  const getWsUrl = () => {
    const loggerUrl = (axios.defaults.baseURL || process.env.REACT_APP_CHATBOT_BACKEND);
    const url = new URL(loggerUrl);

    url.pathname = `ws`;
    return url.href;
  }


  useEffect(() => {
    let stompClient = null;

    const setupWebSocket = async () => {
      // Get WebSocket base URL from runtime config
      const wsBaseUrl = getWsUrl();
      // Create SockJS socket
      const socket = new SockJS(`${wsBaseUrl}`);

      const token = localStorage.getItem(TOKEN);
      // Create STOMP client
      stompClient = new Client({
        webSocketFactory: () => socket,
        connectHeaders: token ? {Authorization: `Bearer ${token}`} : {},
        debug: (str) => {
          console.log("STOMP: ", str);
        },
        reconnectDelay: 5000,
        heartbeatIncoming: 4000,
        heartbeatOutgoing: 4000,
      });

      // Handle connection
      stompClient.onConnect = () => {
        console.log("WebSocket connected");
        setStatus("CONNECTED")
        // Subscribe to updates
        stompClient?.subscribe(topic, (message) => {
          try {
            const update = JSON.parse(message.body);
            console.log("STOMP MESSAGE RECEIVE", update)

            // Check if value is not null and has an id
            if (!update) {
              return;
            }
            setUpdatedValue(update)
            // Update the appropriate array based on table name and action
          } catch (error) {
            console.error("Error processing WebSocket message:", error);
          }
        });
      };

      stompClient.onStompError = (frame) => {
        console.error("STOMP error:", frame);
        setStatus("ERROR");
      };

      // Activate the client
      stompClient.activate();
      stompClientRef.current = stompClient;
    };

    // Initialize WebSocket connection
    if (topic){
      setupWebSocket();
    }

    // Cleanup on unmount
    return () => {
      if (stompClientRef?.current) {
        stompClientRef.current.deactivate();
      }
    };
  }, [topic]);

  return [updatedValue, status]
}